module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eventLog"
  }, [_c('h1', [_vm._v("Event Log")]), _vm._v(" "), _c('el-form', {
    ref: "eventForm",
    staticClass: "form-inline",
    attrs: {
      "inline": true,
      "model": _vm.eventForm
    }
  }, [_c('el-cascader', {
    ref: "eventCascader",
    attrs: {
      "options": _vm.options,
      "show-all-levels": false,
      "placeholder": "Select Event Type"
    },
    on: {
      "change": _vm.elCascaderOnlick
    }
  }), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDataPicker),
      expression: "showDataPicker"
    }],
    attrs: {
      "type": "daterange",
      "value-format": "timestamp",
      "range-separator": "To",
      "start-placeholder": "Start Date",
      "end-placeholder": "End Date"
    },
    model: {
      value: (_vm.dataRangeValue),
      callback: function($$v) {
        _vm.dataRangeValue = $$v
      },
      expression: "dataRangeValue"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.searching
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEventLog),
      expression: "showEventLog"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.searching),
      expression: "searching"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.eventData,
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      },
      "cell-style": _vm.cellStyle
    },
    on: {
      "cell-click": _vm.handleCellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "event_type",
      "label": "Event Type",
      "formatter": _vm.eventTypeFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event_time",
      "label": "Event Time [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "method",
      "label": "Event Method"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc",
      "label": "Event Description"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "result",
      "label": "Event Result",
      "formatter": _vm.eventResultFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detail",
      "label": "Event Detail",
      "formatter": _vm.eventDetailFormat
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Event Detail",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dialogData,
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      },
      "cell-style": {
        textAlign: 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outerlicense",
      "label": "Outer License"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "interlicense",
      "label": "Inter License"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "er_num",
      "label": "ER Number",
      "formatter": _vm.arrayFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "license_content",
      "label": "License Content",
      "formatter": _vm.jsonFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project",
      "label": "Project Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "direct_cus",
      "label": "Direct Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_email",
      "label": "Customer Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exp_date",
      "label": "Expiry Date [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEventLog),
      expression: "showEventLog"
    }],
    attrs: {
      "current-page": _vm.curPage,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.numOfData
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-305a4638","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventLog.vue
// module id = 1Qnx
// module chunks = 1